import { useTranslation } from "react-i18next";

const Recovery = () => {
    const { t } = useTranslation();

    return (
        <>{t("Auth##account verification##recovery code##secondary text")}</>
    );
};

export default Recovery;
